import React from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  IconButton,
} from "@mui/material";
import type { TransitionProps } from "@mui/material/transitions";
import "../../../../assets/css/page/CommonModal.scss";
import { ReactComponent as CloseIcon } from "../../../../assets/Images/CrossIcon.svg";
import BaseButton from "../../Common/Buttons/BaseButton";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Fade ref={ref} {...props} />;
});

const CommonModal = ({
  heading,
  body,
  show,
  toggle,
  size = 600,
  handleSave,
  handlePrevious = () => {},
  saveButtonText = "Save",
  spin = false,
  style = {},
  footer = true,
  handleNext = () => {},
  nextButtonText = "",
  showSaveButton = true,
  showNextButton = false,
  showPreviousButton = false,
  disableNextButton = false,
  disableSaveButton = false,
  customClassName = "",
  loadNextButton = false,
  maxModalHeight = "70vh",
}) => {
  return (
    <Dialog
      open={show}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          toggle(event);
        }
      }}
      scroll="paper"
      fullWidth
      maxWidth={false}
      transitionDuration={500}
      slots={{ transition: Transition }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            width: `min(${size}px, calc(100vw - 32px))`,
            transformOrigin: "center",
            transition: "transform 0.3s ease, opacity 0.3s ease",
            ...style,
          },
          className: customClassName,
        },
      }}
      sx={{
        "& .MuiDialog-container": { alignItems: "flex-start" },
      }}
    >
      <DialogTitle className="new-modal-header flex-between">
        <span className="font-16-700-grey capitalize">{heading}</span>
        <IconButton onClick={toggle} className="modal-cross-icon" size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          paddingTop: "20px !important",
          maxHeight: maxModalHeight,
          overflowY: "auto",
          overflowX: "hidden",
          scrollbarWidth: "none",
        }}
      >
        {body}
      </DialogContent>
      {footer && (
        <DialogActions className="new-modal-footer">
          <Box
            className="flex-align-center"
            sx={{
              justifyContent:
                showNextButton && showPreviousButton
                  ? "space-between"
                  : "flex-end",
              gap: "13px",
              width: "100%",
              flexWrap: "wrap",
            }}
          >
            {showPreviousButton && (
              <BaseButton
                variant="outlined"
                title="Previous"
                handleClick={handlePrevious}
              />
            )}
            <Box className="flex-xy-center" sx={{ display: "flex", gap: 2 }}>
              {showNextButton && (
                <BaseButton
                  variant="outlined"
                  title={nextButtonText}
                  disabled={disableNextButton}
                  loading={loadNextButton}
                  handleClick={nextButtonText === "Back" ? toggle : handleNext}
                />
              )}
              {showSaveButton && (
                <BaseButton
                  variant="contained"
                  title={saveButtonText}
                  disabled={spin || disableSaveButton}
                  loading={spin}
                  handleClick={handleSave}
                />
              )}
            </Box>
          </Box>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CommonModal;
